import React from 'react';
import TabByTestTypeSwitcher from './Tabs/TabByTestTypeSwitcher';
import CTMonitoringPanelByTestType from './TestMonitoring/CTMonitoringPanelByTestType';
import WideTabPanel from '@/Components/Tab/WideTabPanel';
import DetailsTab from './Tabs/DetailsTab';
import { mainTestTypesRenderingOrder } from '../../Utils/Utils';
import { useCandidatesResultsContext } from '../Contexts/CandidateResultsContext';
import {
    getCandidateResultsTabValue,
    isTestCompleted,
    mapTestTypeToResultTabType,
    ResultTabType,
} from '../Utils/ResultsUtils';
import ExperienceTab from './Tabs/ExperienceTab';
import NotesTab from './Tabs/NotesTab/NotesTab';

function ResultsTabContent(): React.JSX.Element {
    const { results, activeTestDetailsTab } = useCandidatesResultsContext();

    return (
        <>
            {mainTestTypesRenderingOrder.map((testType) => {
                const resultTabType = mapTestTypeToResultTabType(testType);

                if (isTestCompleted(results, testType)) {
                    return (
                        <WideTabPanel
                            key={resultTabType}
                            tabKey={getCandidateResultsTabValue(resultTabType)}
                            value={activeTestDetailsTab}
                        >
                            <TabByTestTypeSwitcher testType={testType} />
                            <CTMonitoringPanelByTestType testType={testType} {...results} />
                        </WideTabPanel>
                    );
                }
                return null;
            })}
            <WideTabPanel
                key={ResultTabType.Experience}
                tabKey={getCandidateResultsTabValue(ResultTabType.Experience)}
                value={activeTestDetailsTab}
            >
                <ExperienceTab />
            </WideTabPanel>
            <WideTabPanel
                key={ResultTabType.ApplicantInformation}
                tabKey={getCandidateResultsTabValue(ResultTabType.ApplicantInformation)}
                value={activeTestDetailsTab}
            >
                <DetailsTab />
            </WideTabPanel>
            <WideTabPanel
                key={ResultTabType.Note}
                tabKey={getCandidateResultsTabValue(ResultTabType.Note)}
                value={activeTestDetailsTab}
            >
                <NotesTab />
            </WideTabPanel>
        </>
    );
}

export default ResultsTabContent;
